<template>
  <span v-if="maxRelevance" class="score" :class="relevanceTier">
    <span class="bar-1"></span>
    <span class="bar-2"></span>
    <span class="bar-3"></span>
  </span>
</template>

<script>
import { createNamespacedHelpers } from 'vuex';

const { mapGetters } = createNamespacedHelpers('search');

export default {
  name: 'SearchResultScore',

  props: {
    /** @type {import('vue').PropOptions<import('../store/state').SearchResult>} */
    result: {
      type: Object,
      required: true,
    },
  },

  computed: {
    ...mapGetters(['relevanceTiers', 'maxRelevance']),

    /** @returns {string} */
    relevanceTier() {
      return this.relevance >= this.relevanceTiers[2]
        ? 'score-best'
        : this.relevance >= this.relevanceTiers[1]
        ? 'score-better'
        : 'score-good';
    },

    /** @returns {number} */
    relevance() {
      return this.result.score;
    },
  },
};
</script>
